import {connect} from 'react-redux';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Button, Col, Icon, Row} from "antd";
import * as translations from "../../../constants/translations";
import {Link} from "react-router-dom";
import * as APP_CONFIG from "../../../constants/config";
const {benchmarkApi} = APP_CONFIG;

class InverterView extends Component {

    static propTypes = {
        match: PropTypes.shape({
            params: PropTypes.shape({
                id: PropTypes.string.isRequired
            }).isRequired
        }).isRequired
    };

    state = {
        data: 'not loaded'
    };

    componentDidMount = async () => {
        await this.loadData(this.props.match.params.id);
    };

    componentWillReceiveProps = async (nextProps) => {
        if(this.props.match.params.id !== nextProps.match.params.id)
            await this.loadData(nextProps.match.params.id);
    };

    loadData = async (id) => {
        const request = await fetch(`${benchmarkApi}inverters/${id}`);
        const data = await request.json();
        this.setState({data});
    };

    renderCol = (key, val) => {
        return <Row gutter={{xs: 0, md: 24}} className="dataview-row">
            <Col xs={24} md={8} className="dataview-label">{translations.inverter[key] ? translations.inverter[key] : key}</Col>
            <Col xs={24} md={15} className="dataview-value">{val === true || val === false ? (
                <Icon type={val ? "check-circle" : "close-circle"} size="default"/>
            ): val}</Col>
        </Row>;
    }

    render() {
        const {data} = this.state;
        return (
            <div>

                {data.id ?
                    <div>
                        <h1>{data.name}</h1>
                        {Object.keys(data).filter(key => key !== "name").map((key) => this.renderCol(key, data[key]))}
                        <div>
                            <Link to={`/omvormers/${data.id}/bewerk`}>
                                <Button type={'primary'}>Bewerken</Button>
                            </Link>
                        </div>
                    </div> : ''}
            </div>
        );
    }
}

const mapStateToProps = (state) => {return {}};

export default connect(mapStateToProps)(InverterView);



// WEBPACK FOOTER //
// ./src/components/baseinfo/inverters/view.js